import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  riskDataService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './sync-riskType-dialog.controller';
import template from './sync-riskType-dialog.html';
import risk from '../risk';
import syncRiskConfirmDialog from '../dialog.syncRiskConfirmDialog';


class dialogService {
  getOptions($event, {
    // eslint-disable-next-line no-shadow
    riskType,
  }) {
    return {
      controller,
      controllerAs: 'syncRiskTypeVM',
      locals: {
        riskType,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.risk.syncRiskTypeDialog', [
  loaderService,
  alerts,
  confirmDialog,
  ssDialogService,
  riskDataService,
  risk,
  syncRiskConfirmDialog
])
  .service('syncRiskTypeDialog', dialogService)
  .name;
